import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_ShortDepressionTest = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_ShortDepressionTest' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3>Short Depression Test</h3></p>
                <p className='w-750'>Use this short depression test to help determine if you have the symptoms of depression and whether you should seek a diagnosis or treatment for depression from a qualified doctor or mental health professional. This depression test is the Goldberg Depression Questionnaire.
                    <br/><br/>
                    <b>Instructions:</b>You might reproduce this scale and use it on a weekly basis to track your moods. It also might be used to show your doctor how your depression symptoms have changed from one visit to the next. Changes of five or more points are significant. This scale is not designed to make a diagnosis of depression or take the place of a professional diagnosis. If you suspect that you are depressed, please consult with a mental health professional as soon as possible.
                    <br/><br/>
                    The 18 items below refer to how you have felt and behaved during the past week. For each item, indicate the extent to which it is true, by checking the appropriate box next to the item.
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>1. I do things slowly.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIDoThingsSlowly_1' name='rbIDoThingsSlowly' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIDoThingsSlowly_2' name='rbIDoThingsSlowly' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIDoThingsSlowly_3' name='rbIDoThingsSlowly' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIDoThingsSlowly_4' name='rbIDoThingsSlowly' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIDoThingsSlowly_5' name='rbIDoThingsSlowly' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIDoThingsSlowly_6' name='rbIDoThingsSlowly' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>2. My future seems hopeless.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMyFutureSeemsHopeless_1' name='rbMyFutureSeemsHopeless' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMyFutureSeemsHopeless_2' name='rbMyFutureSeemsHopeless' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMyFutureSeemsHopeless_3' name='rbMyFutureSeemsHopeless' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMyFutureSeemsHopeless_4' name='rbMyFutureSeemsHopeless' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMyFutureSeemsHopeless_5' name='rbMyFutureSeemsHopeless' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMyFutureSeemsHopeless_6' name='rbMyFutureSeemsHopeless' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>3. It is hard for me to concentrate on reading.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbItIsHardForMeToConcentrateOnReading_1' name='rbItIsHardForMeToConcentrateOnReading' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbItIsHardForMeToConcentrateOnReading_2' name='rbItIsHardForMeToConcentrateOnReading' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbItIsHardForMeToConcentrateOnReading_3' name='rbItIsHardForMeToConcentrateOnReading' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbItIsHardForMeToConcentrateOnReading_4' name='rbItIsHardForMeToConcentrateOnReading' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbItIsHardForMeToConcentrateOnReading_5' name='rbItIsHardForMeToConcentrateOnReading' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbItIsHardForMeToConcentrateOnReading_6' name='rbItIsHardForMeToConcentrateOnReading' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>4. The pleasure and joy has gone out of my life.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThePleasureAndJoyHasGoneOutOfMyLife_1' name='rbThePleasureAndJoyHasGoneOutOfMyLife' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThePleasureAndJoyHasGoneOutOfMyLife_2' name='rbThePleasureAndJoyHasGoneOutOfMyLife' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThePleasureAndJoyHasGoneOutOfMyLife_3' name='rbThePleasureAndJoyHasGoneOutOfMyLife' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbThePleasureAndJoyHasGoneOutOfMyLife_4' name='rbThePleasureAndJoyHasGoneOutOfMyLife' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThePleasureAndJoyHasGoneOutOfMyLife_5' name='rbThePleasureAndJoyHasGoneOutOfMyLife' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbThePleasureAndJoyHasGoneOutOfMyLife_6' name='rbThePleasureAndJoyHasGoneOutOfMyLife' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>5. I have difficulty making decisions.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveDifficultyMakingDecisions_1' name='rbIHaveDifficultyMakingDecisions' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveDifficultyMakingDecisions_2' name='rbIHaveDifficultyMakingDecisions' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveDifficultyMakingDecisions_3' name='rbIHaveDifficultyMakingDecisions' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveDifficultyMakingDecisions_4' name='rbIHaveDifficultyMakingDecisions' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveDifficultyMakingDecisions_5' name='rbIHaveDifficultyMakingDecisions' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveDifficultyMakingDecisions_6' name='rbIHaveDifficultyMakingDecisions' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>6. I have lost interest in aspects of life that used to be important to me.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveLostInterestInAspectsOfLifeThatUsed_1' name='rbIHaveLostInterestInAspectsOfLifeThatUsed' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveLostInterestInAspectsOfLifeThatUsed_2' name='rbIHaveLostInterestInAspectsOfLifeThatUsed' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveLostInterestInAspectsOfLifeThatUsed_3' name='rbIHaveLostInterestInAspectsOfLifeThatUsed' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveLostInterestInAspectsOfLifeThatUsed_4' name='rbIHaveLostInterestInAspectsOfLifeThatUsed' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveLostInterestInAspectsOfLifeThatUsed_5' name='rbIHaveLostInterestInAspectsOfLifeThatUsed' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIHaveLostInterestInAspectsOfLifeThatUsed_6' name='rbIHaveLostInterestInAspectsOfLifeThatUsed' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>7. I feel sad, blue, and unhappy.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelSadBlueAndUnhappy_1' name='rbIFeelSadBlueAndUnhappy' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelSadBlueAndUnhappy_2' name='rbIFeelSadBlueAndUnhappy' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelSadBlueAndUnhappy_3' name='rbIFeelSadBlueAndUnhappy' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelSadBlueAndUnhappy_4' name='rbIFeelSadBlueAndUnhappy' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelSadBlueAndUnhappy_5' name='rbIFeelSadBlueAndUnhappy' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelSadBlueAndUnhappy_6' name='rbIFeelSadBlueAndUnhappy' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>8. I am agitated and keep moving around.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIAmAgitatedAndKeepMovingAround_1' name='rbIAmAgitatedAndKeepMovingAround' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIAmAgitatedAndKeepMovingAround_2' name='rbIAmAgitatedAndKeepMovingAround' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIAmAgitatedAndKeepMovingAround_3' name='rbIAmAgitatedAndKeepMovingAround' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIAmAgitatedAndKeepMovingAround_4' name='rbIAmAgitatedAndKeepMovingAround' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIAmAgitatedAndKeepMovingAround_5' name='rbIAmAgitatedAndKeepMovingAround' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIAmAgitatedAndKeepMovingAround_6' name='rbIAmAgitatedAndKeepMovingAround' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>9. I feel fatigued.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelFatigued_1' name='rbIFeelFatigued' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelFatigued_2' name='rbIFeelFatigued' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelFatigued_3' name='rbIFeelFatigued' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelFatigued_4' name='rbIFeelFatigued' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelFatigued_5' name='rbIFeelFatigued' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelFatigued_6' name='rbIFeelFatigued' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>10. It takes great effort for me to do simple things.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbItTakesGreatEffortForMeSimpleThings_1' name='rbItTakesGreatEffortForMeSimpleThings' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbItTakesGreatEffortForMeSimpleThings_2' name='rbItTakesGreatEffortForMeSimpleThings' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbItTakesGreatEffortForMeSimpleThings_3' name='rbItTakesGreatEffortForMeSimpleThings' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbItTakesGreatEffortForMeSimpleThings_4' name='rbItTakesGreatEffortForMeSimpleThings' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbItTakesGreatEffortForMeSimpleThings_5' name='rbItTakesGreatEffortForMeSimpleThings' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbItTakesGreatEffortForMeSimpleThings_6' name='rbItTakesGreatEffortForMeSimpleThings' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>11. I feel that I am a guilty person who deserves to be punished.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished_1' name='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished_2' name='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished_3' name='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished_4' name='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished_5' name='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished_6' name='rbIFeelThatIAmGuiltyPersonWhoDeservesToBePunished' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>12. I feel like a failure.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLikeAFailure_1' name='rbIFeelLikeAFailure' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLikeAFailure_2' name='rbIFeelLikeAFailure' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLikeAFailure_3' name='rbIFeelLikeAFailure' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLikeAFailure_4' name='rbIFeelLikeAFailure' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLikeAFailure_5' name='rbIFeelLikeAFailure' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLikeAFailure_6' name='rbIFeelLikeAFailure' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>13. I feel lifeless -- more dead than alive.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLifeLessMoreDeadThanAlive_1' name='rbIFeelLifeLessMoreDeadThanAlive' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLifeLessMoreDeadThanAlive_2' name='rbIFeelLifeLessMoreDeadThanAlive' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLifeLessMoreDeadThanAlive_3' name='rbIFeelLifeLessMoreDeadThanAlive' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLifeLessMoreDeadThanAlive_4' name='rbIFeelLifeLessMoreDeadThanAlive' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLifeLessMoreDeadThanAlive_5' name='rbIFeelLifeLessMoreDeadThanAlive' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelLifeLessMoreDeadThanAlive_6' name='rbIFeelLifeLessMoreDeadThanAlive' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>14. My sleep has been disturbed -- too little, too much, or broken sleep.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMySleepHasBeenDisturbedTooLittle_1' name='rbMySleepHasBeenDisturbedTooLittle' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMySleepHasBeenDisturbedTooLittle_2' name='rbMySleepHasBeenDisturbedTooLittle' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMySleepHasBeenDisturbedTooLittle_3' name='rbMySleepHasBeenDisturbedTooLittle' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMySleepHasBeenDisturbedTooLittle_4' name='rbMySleepHasBeenDisturbedTooLittle' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMySleepHasBeenDisturbedTooLittle_5' name='rbMySleepHasBeenDisturbedTooLittle' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbMySleepHasBeenDisturbedTooLittle_6' name='rbMySleepHasBeenDisturbedTooLittle' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>15. I spend time thinking about HOW I might kill myself.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbISpendTimeThinkingAboutHowMightKillMyself_1' name='rbISpendTimeThinkingAboutHowMightKillMyself' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbISpendTimeThinkingAboutHowMightKillMyself_2' name='rbISpendTimeThinkingAboutHowMightKillMyself' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbISpendTimeThinkingAboutHowMightKillMyself_3' name='rbISpendTimeThinkingAboutHowMightKillMyself' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbISpendTimeThinkingAboutHowMightKillMyself_4' name='rbISpendTimeThinkingAboutHowMightKillMyself' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbISpendTimeThinkingAboutHowMightKillMyself_5' name='rbISpendTimeThinkingAboutHowMightKillMyself' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbISpendTimeThinkingAboutHowMightKillMyself_6' name='rbISpendTimeThinkingAboutHowMightKillMyself' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>16. I feel trapped or caught.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelTrappedOrCaught_1' name='rbIFeelTrappedOrCaught' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelTrappedOrCaught_2' name='rbIFeelTrappedOrCaught' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelTrappedOrCaught_3' name='rbIFeelTrappedOrCaught' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelTrappedOrCaught_4' name='rbIFeelTrappedOrCaught' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelTrappedOrCaught_5' name='rbIFeelTrappedOrCaught' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelTrappedOrCaught_6' name='rbIFeelTrappedOrCaught' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>17. I feel depressed even when good things happen to me.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelDepressedEvenWhenGoodThingsHappenToMe_1' name='rbIFeelDepressedEvenWhenGoodThingsHappenToMe' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelDepressedEvenWhenGoodThingsHappenToMe_2' name='rbIFeelDepressedEvenWhenGoodThingsHappenToMe' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelDepressedEvenWhenGoodThingsHappenToMe_3' name='rbIFeelDepressedEvenWhenGoodThingsHappenToMe' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelDepressedEvenWhenGoodThingsHappenToMe_4' name='rbIFeelDepressedEvenWhenGoodThingsHappenToMe' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelDepressedEvenWhenGoodThingsHappenToMe_5' name='rbIFeelDepressedEvenWhenGoodThingsHappenToMe' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbIFeelDepressedEvenWhenGoodThingsHappenToMe_6' name='rbIFeelDepressedEvenWhenGoodThingsHappenToMe' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>18. Without trying to diet, I have lost, or gained, weight.</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbWithoutTryingToDietHaveGainedWeight_1' name='rbWithoutTryingToDietHaveGainedWeight' className='add-only' value='NotAtAll'/>  Not at all</td>
                        <td className='w-250'>
                            <input type='radio' id='rbWithoutTryingToDietHaveGainedWeight_2' name='rbWithoutTryingToDietHaveGainedWeight' className='add-only' value='JustLittle'/> Just a little</td>
                        <td className='w-250'>
                            <input type='radio' id='rbWithoutTryingToDietHaveGainedWeight_3' name='rbWithoutTryingToDietHaveGainedWeight' className='add-only' value='Somewhat'/>  Somewhat</td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbWithoutTryingToDietHaveGainedWeight_4' name='rbWithoutTryingToDietHaveGainedWeight' className='add-only' value='Moderately'/>   Moderately</td>
                        <td className='w-250'>
                            <input type='radio' id='rbWithoutTryingToDietHaveGainedWeight_5' name='rbWithoutTryingToDietHaveGainedWeight' className='add-only' value='QuiteLot'/>  Quite a lot</td>
                        <td className='w-250'>
                            <input type='radio' id='rbWithoutTryingToDietHaveGainedWeight_6' name='rbWithoutTryingToDietHaveGainedWeight' className='add-only' value='VeryMuch'/>  Very much</td>
                    </tr>
                </table>

                

















            </div>
        </form>

    )
}   